var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof LiquidSpaceEmbedded !== "undefined") return resolve();
	__webpack_require__.l("/Content/dist/js/embedded-client.js?h=5d198823aaa985dc6961f18b7203fed8b3dc055e5a796cc1281abafdcfec45c0", (event) => {
		if(typeof LiquidSpaceEmbedded !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "LiquidSpaceEmbedded");
}).then(() => (LiquidSpaceEmbedded));